import React from 'react';
import Moment from 'react-moment';

import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';

import { AuthService } from '../../services/auth';
import { BundleLink } from '../BundleLink';
import { QuoteLink } from '../QuoteLink';
import { DeereCachedFetch } from '../../shared/fetch';
import { QuoteDetails } from '../QuoteDetails';
import { AssignTo } from '../AssignTo';

import styles from './index.css';

export class QuoteSearchCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statuses: {}
        };

        /**
     * @type {React.RefObject<HTMLElement>}
     */
        this.panel = React.createRef();
    }

    async componentDidMount() {
        this.setState({
            loading: false
        });

        try {
            const promises = [];

            promises.push(AuthService.user);

            if (this.props.expanded) {
                promises.push(this.requestThirdParties());
            }

            const [user] = await Promise.all(promises);

            this.setState({
                user
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    async componentDidUpdate(prevProps) {
        if (this.props.expanded !== prevProps.expanded && this.props.expanded) {
            await this.requestThirdParties();
        }
    }

    async requestThirdParties() {
        if (this.state.thirdParties) return;

        this.setState({
            thirdParties: await DeereCachedFetch('/api/third-parties', {
                query: {
                    quoteNumber: this.props.quote.quoteNumber
                }
            })
        });
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    scrollTo() {
        this.panel.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }

    assigned(quote, includeID) {
        if (quote.assignment && quote.assignment.user) {
            return `${quote.assignment.user.firstName} ${quote.assignment.user.lastName}${includeID ? ` (${quote.assignment.userID})` : ''}`;
        }

        return 'Unassigned';
    }

    render() {
        return (
            <Accordion TransitionProps={{ unmountOnExit: true }} className={styles.root} expanded={this.props.expanded} key={this.props.quote.quoteNumber} onChange={this.props.onExpanded}>
                <AccordionSummary className={`${styles.sticky} ${styles[this.props.quote.status.replace(' ', '')]}`}>
                    <div className={styles.cell} ref={this.panel}>
                        <BundleLink bundleNumber={this.props.quote.bundleNumber} />
                    </div>
                    <div className={styles.cell}>
                        <QuoteLink quoteNumber={this.props.quote.quoteNumber} />
                    </div>
                    <Typography className={styles.cell} title={`${this.props.quote.country} (${this.props.quote.countryCode})`}>
                        {this.props.quote.country}
                    </Typography>
                    <Typography className={styles.cell}>
                        {this.props.quote.status}
                    </Typography>
                    <Moment className={styles.cell} format="YYYY/MM/DD">

                        {this.props.quote.createdDate || this.props.quote.updatedDate}

                    </Moment>
                    <Typography className={styles.cell} title={this.assigned(this.props.quote, true)}>
                        {this.assigned(this.props.quote)}
                    </Typography>
                    {['ASSIGN', 'ADMIN'].includes(AuthService.role) && (
                        <AssignTo className={styles.cell}
                            disabled={this.props.quote.status !== 'Open' || !this.state.user || !this.state.user.countries.find((country) => country.id.countryCode === this.props.quote.countryCode)}
                            onAssign={this.props.onChange}
                            quote={this.props.quote}
                            style={{ flex: 2, overflow: 'visible', justifyContent: 'flex-end' }} />

                    )}



                </AccordionSummary>
                <AccordionDetails style={{ borderTop: '1px solid rgba(0, 0, 0, 0.2)' }}>
                    <QuoteDetails loggedInUser={this.state.user} onChange={this.props.onChange} quote={this.props.quote} thirdParties={this.state.thirdParties}/>
                </AccordionDetails>
            </Accordion>
        )
    }
}
